import React, { PropsWithChildren } from "react";
//#region components
import { Grid } from "@mui/material";
//#endregion
import cssExports from "theme/styles/main.module.scss";

interface AgentPanelProps {
  label: React.ReactNode;
  footnote?: React.ReactNode;
}

const AgentPanel: React.FC<PropsWithChildren<AgentPanelProps>> = ({ label, footnote, children }) => (
  <Grid container direction="column" className={cssExports.agentPanel}>
    <div className={cssExports.agentPanelLabel}>{label}</div>
    {children}
    {footnote ? <div className={cssExports.agentPanelFootnote}>{footnote}</div> : null}
  </Grid>
);

export default AgentPanel;
